/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruleslocked2Inputs */

const en_dropruleslocked2 = /** @type {(inputs: Dropruleslocked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rules are locked once the drop is live.`)
};

const de_dropruleslocked2 = /** @type {(inputs: Dropruleslocked2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeln sind gesperrt, sobald der Drop live ist.`)
};

/**
* | output |
* | --- |
* | "Rules are locked once the drop is live." |
*
* @param {Dropruleslocked2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruleslocked2 = /** @type {((inputs?: Dropruleslocked2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruleslocked2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruleslocked2(inputs)
	return de_dropruleslocked2(inputs)
});
export { dropruleslocked2 as "dropRulesLocked" }